var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvadoValues(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:url(#c);}.c{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 93,
    height: 93,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#ff5fa2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#ff6a99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#ff8983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb762"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-763.609 -45.57)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(772.609 51.57)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "matrix(1, 0, 0, 1, -9, -6)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    transform: "translate(9 6)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(782.593 68.927)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M681,101.854h-.057a3.039,3.039,0,0,1-2.21-.963L657.076,77.735a14.227,14.227,0,0,1,0-19.179,12.562,12.562,0,0,1,18.519,0L680.98,64.3l5.382-5.741a12.563,12.563,0,0,1,18.52,0,14.227,14.227,0,0,1,0,19.181l-21.658,23.154a3.044,3.044,0,0,1-2.216.963ZM666.338,60.563a6.581,6.581,0,0,0-4.824,2.151,8.059,8.059,0,0,0,0,10.866L680.98,94.389l19.464-20.808a8.06,8.06,0,0,0,0-10.868h0a6.486,6.486,0,0,0-9.649,0l-7.6,8.107a3.038,3.038,0,0,1-4.435,0l-7.6-8.107A6.581,6.581,0,0,0,666.338,60.563Z",
    transform: "translate(-653.359 -54.483)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvadoValues);
export default __webpack_public_path__ + "static/media/avado-values.279132811c07011eee298c650af11b7b.svg";
export { ForwardRef as ReactComponent };